module.exports = __webpack_public_path__ + "toolkit-static/img/laihua-logo-dark.b7947d6b.svg";